export default "__VITE_ASSET__BljmMthg__"